/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type ConfigurableBlockListItem_block$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ConfigurableBlockList_viewer$ref: FragmentReference;
export type ConfigurableBlockList_viewer = {|
  +blocks: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: ConfigurableBlockListItem_block$ref,
      |}
    |}>
  |},
  +$refType: ConfigurableBlockList_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ConfigurableBlockList_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "blocks",
      "name": "configurableBlocks",
      "storageKey": null,
      "args": null,
      "concreteType": "ConfigurableBlockConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ConfigurableBlockEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ConfigurableBlock",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "ConfigurableBlockListItem_block",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '3d0a36b6a1c2c246e492a7de54fee631';
module.exports = node;



// WEBPACK FOOTER //
// src/components/configurable-blocks/__generated__/ConfigurableBlockList_viewer.graphql.js